import { TranslationKey } from 'modules/i18n';
import { HardSkillEntry } from 'utils/cv-form-db';

export const initialValues: HardSkillEntry = {
  name: '',
  level: '',
  professionallyUsed: false
};

export const skillLevelOptions: { key: string; value: TranslationKey }[] = [
  {
    key: 'beginner',
    value: 'cvBuilderPage.hardSkills.form.level.beginner.label'
  },
  {
    key: 'intermediate',
    value: 'cvBuilderPage.hardSkills.form.level.intermediate.label'
  },
  {
    key: 'advanced',
    value: 'cvBuilderPage.hardSkills.form.level.advanced.label'
  }
];

export const USE_HARD_SKILLS_QUERY_KEY = 'hardSkills';
export const HARD_SKILLS_API_URL = 'data/hardSkills';
